import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Router, RouterStateSnapshot} from '@angular/router';
import {AuthenticationService} from './authentication.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard  {

  constructor(
    private router: Router,
    private authService: AuthenticationService
  ) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    // Wait for authentication to be initialized
    if (!this.authService.isAuthInitialized) {
      // If auth is not initialized yet, redirect to login temporarily
      // The APP_INITIALIZER will handle the proper redirect once auth is complete
      this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
      return false;
    }

    const storedUser = localStorage.getItem('currentUser');
    if (storedUser) {
      const user = JSON.parse(storedUser);
      if (user['passwordReset'] === true) {
        console.log('Password reset true?');
        this.router.navigate(['/force-change-password'], { queryParams: { returnUrl: state.url } });
        return false;
      }

      // logged in so return true
      return true;
    }

    // not logged in so redirect to login page with the return url
    this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
    return false;
  }
}
